class InvestMentCard {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
		self.pulledUp = false;
	}

	init() {
		let self = this;

		self.elem.addEventListener('click', evt => {
			evt.preventDefault();

			if(self.getWindowWidth() >= 860) {
				self.pulledUp = !self.pulledUp;

				if(self.pulledUp) {
					self.elem.classList.add('pulled-up');
				} else {
					self.elem.classList.remove('pulled-up');
				}
			}		
		});
	}

	getWindowWidth() {
		return window.innerWidth || document.documentElement.clientWidth;
	}
}

export default InvestMentCard;